<script>
import utils from '@/utils/common';

import FormBlock from '@/components/FormBlock.vue';
import UserDetailTileField from '@/components/user/UserDetailTileField.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'UserDetailMainInfoTile',
  components: { FormBlock, AvatarEditable, UserDetailTileField },
  props: {
    value: Object,
    isEditMode: Boolean,
  },
  computed: {
    staticInfo() {
      return [
        { name: 'registration',   title: 'Дата регистрации:',        value: this.value.createdAt,      displayValue: this.createdAt,                    emptyValue: 'не указана',   displayView: 'horizontal' }, //eslint-disable-line
        { name: 'activation',     title: 'Дата активации:',          value: this.value.activatedAt,    displayValue: this.activatedAtDisplayValue,      emptyValue: 'не указана',   displayView: 'horizontal' }, //eslint-disable-line
        { name: 'lastActivity',   title: 'Последняя активность:',    value: this.value.lastActiveAt,   displayValue: this.lastActiveAtDisplayValue,     emptyValue: 'не указана',   displayView: 'horizontal' }, //eslint-disable-line
      ];
    },

    isActive() {
      return !this.value.accountBlocked;
    },

    isConfirmed() {
      return this.value.accountConfirmed;
    },

    createdAt() {
      return this.value.createdAt ? utils.convertDateToString(new Date(this.value.createdAt), 'numeric') : null;
    },

    activatedAtDisplayValue() {
      return this.value.activatedAt ? utils.convertDateToString(new Date(this.value.activatedAt), 'numeric') : 'до 16.04.2024';
    },

    lastActiveAtDisplayValue() {
      return this.value.lastActiveAt ? utils.convertDateToString(new Date(this.value.lastActiveAt), 'numeric') : '—';
    },

    userName() {
      return this.value.name || this.value.email;
    },

    accountStatus() {
      if (!this.value.accountConfirmed) {
        return 'не активен';
      }
      return this.value.accountBlocked ? 'заблокированный аккаунт' : 'активный аккаунт';
    },

    nameSurname() {
      const name = this.value.name ? this.value.name : this.value.email;
      const surname = this.value.surname ? this.value.surname : this.value.email;

      return `${name} ${surname}`;
    },

    userNameFields() {
      return [
        { name: 'name',       title: 'Имя',       value: this.value.name,         displayValue: this.value.name || this.value.email,              emptyValue: 'не указано',   displayView: 'horizontal',    editView: 'vertical',   changeType: 'input' }, //eslint-disable-line
        { name: 'surname',    title: 'Фамилия',   value: this.value.surname,      displayValue: this.value.surname || this.value.email,      emptyValue: 'не указана',   displayView: null,    editView: 'vertical',   changeType: 'input' }, //eslint-disable-line
      ];
    },

    avatar() {
      return (typeof this.value.avatar === 'object') ? this.value.avatar : {};
    },
  },
  methods: {
    onAvatarChanged(avatar) {
      this.$emit('onAvatarChanged', { avatar: avatar?.['@id'] ?? null });
    },

    onChange(field, e) {
      this.$emit('change', { [field]: e });
    },
  },
};
</script>

<template lang="pug">
FormBlock(mobile)
  .b-user-detail-main-info(v-if="value" :class="{ 'edit-mode': isEditMode }")
    ._avatar
      AvatarEditable(:avatar="avatar" :editable="!isEditMode" :class="{ 'avatar-mini': isEditMode }" @change="onAvatarChanged")
    ._name-area(:class="{ 'name-editable': isEditMode }")
      ._name(v-if="!isEditMode") {{ nameSurname }}
      template(v-if="isEditMode")
        UserDetailTileField(v-for="field in userNameFields" :key="field.name" :field="field" :showTitle="isEditMode" :isEditMode="isEditMode" @change="onChange(field.name, $event)")
    ._status(v-if="!isEditMode" :class="{ active: isActive, blocked: !isActive, unconfirmed: !isConfirmed }") {{ accountStatus }}
    ._dates
      UserDetailTileField(v-for="field in staticInfo" :key="field.name" :field="field")
</template>

<style scoped lang="scss">
.user-detail-main-info {
  display: grid;
  grid-template-rows: min-content min-content min-content min-content min-content;
  grid-template-areas:
    "avatar"
    "username"
    "status"
    "dates"
    "account";

  &__avatar {
    display: flex;
    justify-content: center;
    padding-bottom: 30px;
    grid-area: avatar;
  }

  &__name-area {
    padding-bottom: 10px;
    grid-area: username;
  }

  &__name {
    text-align: center;
  }

  &__status {
    font-family: Geometria, sans-serif;
    grid-area: status;
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0.3px;
    text-align: center;
  }

  &__dates {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-top: 45px;
    grid-area: dates;
  }

  &__date {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__account {
    display: flex;
    flex-direction: column;
    gap: 13px;
    padding-top: 15px;
  }

  &__account-type {
    background-color: rgba(245, 247, 249, 1);
    padding: 9px 12px;
    border-radius: 10px;
    grid-area: account;
  }

  &__title {
    font-family: Geometria, sans-serif;
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0.4px;
    line-height: 1.5;
    color: rgba(146, 160, 176, 1);
  }

  &__value {
    font-family: Geometria, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.5;
    color: rgba(30, 49, 71, 1);
  }
}

.edit-mode {
  grid-template-areas:
    "avatar"
    "username"
    "status"
    "account"
    "dates";
}

.avatar-mini {
  border: 2px solid #ffffff;
  width: 60px;
  height: 60px;
}

.name-editable {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: flex-start;
  width: 100%;
  flex-shrink: 0;
}

.active {
  color: rgba(90, 193, 105, 1);
}

.blocked {
  color: rgba(146, 167, 176, 1);
}

.unconfirmed {
  color: rgba(255, 141, 76, 1);
}
</style>
